import React from 'react';
import { color as palette } from "@/constants/palette";

function BarChart() {
  return (
    <svg aria-hidden="true" focusable="false"
      xmlns='http://www.w3.org/2000/svg'
      width='88'
      height='88'
      viewBox='0 0 88 88'
      fill='none'
    >
      <mask
        id='mask0_563_5811'
        style={{ maskType: 'alpha' }}
        maskUnits='userSpaceOnUse'
        x='0'
        y='0'
        width='88'
        height='88'
      >
        <rect
          x='0.5'
          y='0.5'
          width='87'
          height='87'
          fill={palette.lineStrong}
          stroke={palette.fill}
        />
      </mask>
      <g mask='url(#mask0_563_5811)'>
        <path
          d='M10.9987 76.9875C9.96296 76.9875 9.09535 76.6373 8.39504 75.937C7.69472 75.2367 7.34453 74.3691 7.34453 73.3333C7.34453 72.2976 7.69472 71.43 8.39504 70.7297C9.09535 70.0294 9.96296 69.6792 10.9987 69.6792H76.9987C78.0344 69.6792 78.902 70.0294 79.6023 70.7297C80.3027 71.43 80.6529 72.2976 80.6529 73.3333C80.6529 74.3691 80.3027 75.2367 79.6023 75.937C78.902 76.6373 78.0344 76.9875 76.9987 76.9875H10.9987ZM16.4987 65.9875C14.9742 65.9875 13.6788 65.4541 12.6117 64.387C11.5446 63.3199 11.0112 62.0245 11.0112 60.5V45.8333C11.0112 44.3088 11.5446 43.0134 12.6117 41.9463C13.6788 40.8793 14.9742 40.3458 16.4987 40.3458C18.0232 40.3458 19.3186 40.8793 20.3857 41.9463C21.4528 43.0134 21.9862 44.3088 21.9862 45.8333V60.5C21.9862 62.0245 21.4528 63.3199 20.3857 64.387C19.3186 65.4541 18.0232 65.9875 16.4987 65.9875ZM34.832 65.9875C33.3075 65.9875 32.0121 65.4541 30.945 64.387C29.878 63.3199 29.3445 62.0245 29.3445 60.5V27.5C29.3445 25.9755 29.878 24.6801 30.945 23.613C32.0121 22.5459 33.3075 22.0125 34.832 22.0125C36.3565 22.0125 37.652 22.5459 38.719 23.613C39.7861 24.6801 40.3195 25.9755 40.3195 27.5V60.5C40.3195 62.0245 39.7861 63.3199 38.719 64.387C37.652 65.4541 36.3565 65.9875 34.832 65.9875ZM53.1654 65.9875C51.6409 65.9875 50.3454 65.4541 49.2784 64.387C48.2113 63.3199 47.6779 62.0245 47.6779 60.5V38.5C47.6779 36.9755 48.2113 35.6801 49.2784 34.613C50.3454 33.5459 51.6409 33.0125 53.1654 33.0125C54.6899 33.0125 55.9853 33.5459 57.0524 34.613C58.1194 35.6801 58.6529 36.9755 58.6529 38.5V60.5C58.6529 62.0245 58.1194 63.3199 57.0524 64.387C55.9853 65.4541 54.6899 65.9875 53.1654 65.9875ZM71.4987 65.9875C69.9742 65.9875 68.6788 65.4541 67.6117 64.387C66.5446 63.3199 66.0112 62.0245 66.0112 60.5V16.5C66.0112 14.9755 66.5446 13.6801 67.6117 12.613C68.6788 11.5459 69.9742 11.0125 71.4987 11.0125C73.0232 11.0125 74.3186 11.5459 75.3857 12.613C76.4528 13.6801 76.9862 14.9755 76.9862 16.5V60.5C76.9862 62.0245 76.4528 63.3199 75.3857 64.387C74.3186 65.4541 73.0232 65.9875 71.4987 65.9875Z'
          fill={palette.primary}
          stroke={palette.fill}
          strokeWidth='0.025'
        />
      </g>
    </svg>
  );
}

export default BarChart;
